import { registerLocaleData } from "@angular/common";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import localeDECH from "@angular/common/locales/de-CH";
import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { GeoAppInjectionToken, IGeoAppAppInjectionToken, provideGeoappbaseClient } from "@geolib/geoappbase-client";
import { TranslateModule } from "@ngx-translate/core";
import { UIRouterModule } from "@uirouter/angular";
import { LoggerModule, NgxLoggerLevel } from "ngx-logger";
import { AuthenticationService } from "./app/account/AuthenticationService";
import { GeobusLoginService } from "./app/account/GeobusLoginService";
import { IdentityService } from "./app/account/IdentityService";
import AppComponent from "./app/AppComponent";
import AppInitializer from "./app/AppInitializer";
import GridService from "./app/common/GridService";
import { PasswordPolicy } from "./app/common/PasswordPolicy";
import StatusMapping from "./app/common/StatusMapping";
import { FtpServerService } from "./app/ftpServer/FtpServerService";
import { GemeindeService } from "./app/gemeinde/GemeindeService";
import { IntegrationService } from "./app/integration/IntegrationService";
import { ModelService } from "./app/model/ModelService";
import { OrganisationService } from "./app/organisation/OrganisationService";
import { PublicationService } from "./app/publication/PublicationService";
import { states } from "./app/states";
import { TopicService } from "./app/topic/TopicService";
import { GeobusAppService } from "./app/tracking/GeobusAppService";
import { GeopackageService } from "./app/tracking/GeopackageService";
import { TrackingService } from "./app/tracking/TrackingService";
import { EventSubscriptionService } from "./app/user/EventSubscriptionService";
import { UserService } from "./app/user/UserService";
import { environment } from "./environments/environment";

registerLocaleData(localeDECH);

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        provideGeoappbaseClient(),
        importProvidersFrom(
            LoggerModule.forRoot({
                level: NgxLoggerLevel.DEBUG,
                serverLogLevel: NgxLoggerLevel.ERROR,
            }),
        ),
        importProvidersFrom(TranslateModule.forRoot({ extend: true })),
        importProvidersFrom(UIRouterModule.forRoot({ states })),
        AppInitializer,
        AuthenticationService,
        EventSubscriptionService,
        FtpServerService,
        GemeindeService,
        GeobusAppService,
        GeopackageService,
        IdentityService,
        IntegrationService,
        ModelService,
        OrganisationService,
        PasswordPolicy,
        PublicationService,
        StatusMapping,
        TopicService,
        TrackingService,
        UserService,
        GridService,
        GeobusLoginService,
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: GeoAppInjectionToken,
            useValue: Object.freeze<IGeoAppAppInjectionToken>({
                name: "geobus",
                appNamePrefix: "geo",
                appNameSuffix: "bus",
            }),
        },
    ],
}).catch((err) => console.error(err));
